import React from 'react';
import { Box, MenuItem, Pagination, PaginationItem, Select, Typography } from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
} from '@mui/icons-material';
import { tablePaginationControlsStyles } from './styles.ts';

export type TTablePaginationControlsProps = {
  page: number;
  rowsPerPage: number;
  totalElements: number;
  isLoading: boolean;
  rowsPerPageOptions?: number[];
  labelRowsPerPage?: string;
  showSummary?: boolean;
  justifyContent?: 'flex-end' | 'center' | 'space-between';
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

export const TablePaginationControls: React.FC<TTablePaginationControlsProps> = ({
  page,
  rowsPerPage,
  totalElements,
  isLoading,
  rowsPerPageOptions = [rowsPerPage],
  labelRowsPerPage: _labelRowsPerPage = 'Рядків:',
  showSummary = true,
  justifyContent = 'flex-end',
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalElements / rowsPerPage);
  const from = totalElements === 0 ? 0 : page * rowsPerPage + 1;
  const to = Math.min(totalElements, (page + 1) * rowsPerPage);
  const shouldShowRowsPerPageSelector = rowsPerPageOptions.length > 1;

  if (totalElements <= 0) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        ...tablePaginationControlsStyles.root(theme),
        justifyContent,
      })}
    >
      {shouldShowRowsPerPageSelector && (
        <Box sx={tablePaginationControlsStyles.rowsPerPage}>
          <Typography sx={tablePaginationControlsStyles.label}>{_labelRowsPerPage}</Typography>
          <Select
            size="small"
            value={rowsPerPage}
            disabled={isLoading}
            onChange={(event) => onRowsPerPageChange(Number(event.target.value))}
          >
            {rowsPerPageOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}

      {showSummary && (
        <Typography sx={tablePaginationControlsStyles.label}>
          {`Відображено ${from}-${to} з ${totalElements}`}
        </Typography>
      )}

      {totalPages > 1 && (
        <Pagination
          count={totalPages}
          page={page + 1}
          siblingCount={0}
          boundaryCount={1}
          onChange={(_, nextPage) => onPageChange(nextPage - 1)}
          sx={tablePaginationControlsStyles.controls}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              disabled={isLoading || item.disabled}
              slots={{
                previous: ArrowBackIcon,
                next: ArrowForwardIcon,
              }}
              sx={tablePaginationControlsStyles.item}
            />
          )}
        />
      )}
    </Box>
  );
};
